import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin, BadgeCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import FeedbackModal from './Forms/FeedBackModal';

const Footer = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className="footer-container-fb">
        <div className="footer-top-fb">
          {/* Branding */}
          <div className="footer-logo-fb">
            <h2>Sarfare Properties </h2>
            <p>Crafting premium real estate experiences tailored just for you.</p>
          </div>

          {/* Our Services */}
          <div className="footer-services-fb">
            <h4>Our Services</h4>
            <ul>
              <li>Property Buying</li>
              <li>Property Selling</li>
              <li>Property Renting</li>
              <li>Property Management</li>
              <li>Investment Advisory</li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-links-fb">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About</Link></li>
              <li><Link to="/properties">Projects</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li onClick={() => setOpen(true)} style={{ cursor: 'pointer' }}>Feedback</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-fb">
            <h4>Contact Us</h4>
            <p><Phone size={16} /> 9702934357</p>
            <p><MapPin size={16} /> Shop no 58, E wing, Sarova Complex, Samata nagar, Thakur village, Kandivali East, Mumbai-400101</p>
            <p><BadgeCheckIcon size={16} /> A51800044399</p>
          </div>
        </div>

        {/* Social Media */}
        {/* <div className="footer-social-section-fb">
          <h4>Follow Us</h4>
          <div className="footer-icons-fb">
            <a href="#" aria-label="Facebook"><Facebook size={20} /></a>
            <a href="#" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="#" aria-label="LinkedIn"><Linkedin size={20} /></a>
          </div>
        </div> */}

        {/* Footer Bottom */}
        <div className="footer-bottom-fb">
          <p>
            © {new Date().getFullYear()} All rights reserved, Powered By{' '}
            <a
              href="https://100billiontech.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              100billion Tech
            </a>
          </p>
        </div>
      </footer>


      <FeedbackModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Footer;
